import AppOptions from "../app/options";
import GQL from "../gql/gql";
import PagehitData from "../gql/pagehit_data";
import Cookies from "./cookies";
import User from "./user";

class Trackers {
    constructor(
        private gql: GQL,
        private user: User,
        private cookies: Cookies,
        private options: AppOptions
    ) { }

    pageHit(): void {
        let args = {
            page: window.location.href,
            sectionId: this.options.sectionId,
            deviceId: this.user.deviceId || '',
            cookieAgree: this.cookies.cookies?.cookiesAccept || '',
            siteId: this.options.siteId,
            articleId: this.options.articleId,
            categories: this.options.categories,
            recipeId: this.options.recipeId,
        };

        this.gql.pageHit(args);
    }
}

export default Trackers;